import { ExclamationCircleFilled } from '@ant-design/icons'
import { Spin } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import AddIcon from 'components/icons/AddIcon'
import { Text } from 'modules/Onboarding/Register/WorkExperience/style'
import { AdjustIcon } from 'modules/Resume/DrawerComponents/DrawerStyle'
import React, { useEffect, useState } from 'react'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import CheckIconBlue from '../../../components/icons/CheckIconBlue'
import CheckIconGreen from '../../../components/icons/CheckIconGreen'
import CheckIconGrey from '../../../components/icons/CheckIconGrey'
import ThumbsUpIcon from '../../../components/icons/ThumbsUpIcon'
import FilterCheckBoxComp from '../../../components/UIElements/FilterCheckBoxComp'
import { FlexWrapRole, StyledModal } from './style'

import CrossIconSkill from 'components/icons/CrossIconSkill'
import { useDispatch } from 'react-redux'
import CheckboxSelectAll from '../../../components/CheckboxSelectAll/CheckboxSelectAll'
import { StyledDiv } from '../../Dashboard/Style/style'
import { getStudentData } from '../../Resume/actions'
import ExperienceModal from './ExperienceModal'
import {
  AddedSkillHeading,
  AddSkillHeading,
  ButtonLocal,
  ContentStyle,
  CountHeading,
  ExperienceDescription,
  ExperienceNote,
  ExtraPaddingLast,
  ExtraPaddingLeft,
  ExtraPaddingLeftSkill,
  ExtraPaddingLeftSkill1,
  ExtraPaddingNew,
  ExtraPaddingSkills,
  HorizontalDivider,
  HorizontalDividerTitle,
  LocationDescription,
  LocationNote,
  SkillHeading,
  SkillSetHeading,
  SkillsHeading,
  SkillsHeadingPadding,
  SkillsSubHeading,
  SpinWrapper,
  TopHeading,
} from './roleStyle'
import { useSelector } from 'react-redux'

const SkillBasedRoleModal = ({
  roleDrawer,
  selectedNew,
  setRoleDrawer,
  eligibleList,
  getEligibleDetails,
  roleFloatList,
  itemId,
  setLoading,
  loading,
  setWorkExperienceDrawer,
  updateRoleFloatDetails,
  formId = 'role_drawer',
  UpdatedSkills,
  skillVisible,
  locationVisible,
  expVisible,
  expDrawer,
  setUpdateResponse,
  updateResponse,
  setQuestionnaireModal,
  setSelected,
  onApplyClick,
  fetchEligleDetails,
  eligibilityCriteria,
  setInternshipDrawer,
  setProjectDrawer,
  setCourseTrainingDrawer,
  setEduModalVisible,
  fetchEligleDetailsNotLoading
}) => {
  const dispatch = useDispatch()

  const [selectedLocation, setSelectedLocation] = useState([])
  const [combinedArrayLocation, setCombinedArrayLocation] = useState([])
  const [selectedEdu, setSelectedEdu] = useState([])
  const [selectedWork, setSelectedWork] = useState([])
  const [selectedIntern, setSelectedIntern] = useState([])
  const [selectedTraining, setSelectedTraining] = useState([])
  const [showComponent, setShowComponent] = useState(false)
  const [selectedProject, setSelectedProject] = useState([])
  const [educationCheck, setEducationCheck] = useState(false)
  const [projectCheck, setProjectCheck] = useState(false)
  const [internCheck, setInternCheck] = useState(false)
  const [workCheck, setWorkCheck] = useState(false)
  const [trainingCheck, setTrainingCheck] = useState(false)
  const [educationList, setEducationList] = useState([])
  const [workList, setWorkList] = useState([])
  const [projectList, setProjectList] = useState([])
  const [trainingList, setTrainingList] = useState([])
  const [internList, setInternList] = useState([])
  const [allLocationsAdded, setAllLocationsAdded] = useState(true)

  const [preferredLocationsString, setPreferredLocationsString] = useState('')
  const [requiredLocations, setRequiredLocations] = useState('')
  const [experienceFromDate, setExperienceFromDate] = useState('')
  const [experienceToDate, setExperienceToDate] = useState('')
  const [checked, setChecked] = useState(false)
  const [added, setAdded] = useState(false)
  const [addSkills, setAddSkills] = useState(false)
  const [studentExperience, setStudentExperience] = useState('')
  const [addedSkills, setAddedSkills] = useState([])
  const [addedAllSkills, setAddedAllSkills] = useState([])
  const [addedSkill, setAddedSkill] = useState([])
  const [addingSkill, setAddingSkill] = useState(null)
  const [addSkillDisable, setAddSkillDisable] = useState(false)
  const [add, setAdd] = useState(false)
  const campusDetails = useSelector(state => state?.studentData?.campusDetails)
  const accessLevel = campusDetails?.instituteSubscription?.accessLevel
  const [yearCalculate, setYearCalculate] = useState('')
  const [messageState, setMessageState] = useState('')

  // Common function to calculate eligibility message
  const calculateEligibilityMessage = (eligData) => {
    let message = '';
    const isSkillsEligible = !eligData?.skills?.isEligible;
    const isLocationEligible = !eligData?.locations?.isEligible || !eligData?.location?.isEligible;
    const isExperienceEligible = !eligData?.experience?.isEligible;
    
    const hasEligibilityIssue = isSkillsEligible || isLocationEligible || isExperienceEligible;
    
    if (hasEligibilityIssue) {
      if (isSkillsEligible && isLocationEligible && isExperienceEligible) {
        message = 'skills, location, and work experience';
      } else if (isSkillsEligible && isLocationEligible) {
        message = 'skills and location';
      } else if (isSkillsEligible && isExperienceEligible) {
        message = 'skills and work experience';
      } else if (isLocationEligible && isExperienceEligible) {
        message = 'location and work experience';
      } else {
        if (isSkillsEligible) {
          message += 'skills';
        }
        if (isLocationEligible) {
          if (message) message += ' and ';
          message += 'location';
        }
        if (isExperienceEligible) {
          if (message) message += ' and ';
          message += 'work experience';
        }
      }
    }
    
    return message;
  };
  

  useEffect(() => {
    const preferredLocationsString = eligibleList?.locations?.studentLocation
    ?.map(loc => loc?.city_name ?? loc?.state_name)
    ?.join(', ')
    const requiredLocations = eligibleList?.locations?.allLocations
      ?.map(item => item?.name ?? item?.state_name)
      .join(', ')
    const experienceFromDate = eligibleList?.experience?.fromYear
    const experienceToDate = eligibleList?.experience?.toYear
    const studentExperience = eligibleList?.experience?.studentExperience
    const yearCalculate =  formatExperience(eligibleList?.experience?.studentExperience)
    setYearCalculate(yearCalculate)
    setPreferredLocationsString(preferredLocationsString)
    setRequiredLocations(requiredLocations)
    setExperienceFromDate(experienceFromDate)
    setExperienceToDate(experienceToDate)
    setStudentExperience(studentExperience)
    
    // Calculate and set message when eligibility data changes
    if (eligibleList) {
      const newMessage = calculateEligibilityMessage(eligibleList);
      setMessageState(newMessage);
    }
  }, [eligibleList])


  const formatExperience = (decimalYears) => {
    if (!decimalYears || decimalYears <= 0) return '0 year';
  
    // Convert to total months and add 1 month correction
    let totalMonths = Math.round(decimalYears * 12) + 1;
  
    const years = Math.floor(totalMonths / 12);
    const months = totalMonths % 12;
  
    let result = '';
    if (years > 0) result += `${years} year${years > 1 ? 's' : ''}`;
    if (months > 0) {
      if (result) result += ' ';
      result += `${months} month${months > 1 ? 's' : ''}`;
    }
  
    return result || '0 year';
  };

  useEffect(() => {
    const data = eligibleList?.locations?.allLocations?.every(
      location => location?.isAdded
    )
    setAllLocationsAdded(data)
  }, [eligibleList])

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowComponent(true)
    }, 1000)

    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    let uniqueArray = []

    eligibleList?.locations?.allLocations?.forEach(value => {
      if (value?.isAdded) {
        uniqueArray.push(value?.id)
      }
    })
    setSelectedLocation(uniqueArray)
  }, [eligibleList])

  const clearSelectedList = () => {
    setSelectedEdu([])
    setSelectedWork([])
    setSelectedTraining([])
    setSelectedProject([])
    setSelectedIntern([])
  }

  const onCheckboxEdu = list => {
    setSelectedEdu(list)
  }

  const onCheckboxWork = list => {
    setSelectedWork(list)
  }

  const onCheckboxTraining = list => {
    setSelectedTraining(list)
  }

  const onCheckboxProject = list => {
    setSelectedProject(list)
  }
  const onCheckboxIntern = list => {
    setSelectedIntern(list)
  }
  const locationList = eligibleList?.locations?.allLocations?.map(item => ({
    id: item?.id ?? item?.state_id,
    name: item?.name ?? item?.state_name,
  }))
  const onCheckboxLocation = list => {
    const filteredObjects = eligibleList?.locations?.allLocations?.filter(
      item => list?.includes(item?.id ?? item?.state_id) && !item?.isAdded
    ) 

    const locationList = filteredObjects?.map(item => {
      const obj = {};
    
      if (item?.id) obj.city_id = item?.id;
      if (item?.state_id) obj.state_id = item?.state_id;
      if (item?.state_name) obj.state_name = item?.state_name;
      if (item?.name) obj.city_name = item?.name;

      return obj;
    });
    
    setSelectedLocation(list)
    setChecked(list?.length === eligibleList?.locations?.allLocations?.length)

    return locationList
  }

  useEffect(() => {
    const locationList = onCheckboxLocation(selectedLocation)

    const combinedLocation = [locationList]
      .flat()
      .map(item => ({ ...item, selected: false }))
    setCombinedArrayLocation(combinedLocation)
  }, [selectedLocation])

  const onClear = () => {
    setRoleDrawer(false)
    UpdatedSkills()
  }

  const onClearSkill = async () => {
    setEducationCheck(false)
    setProjectCheck(false)
    setInternCheck(false)
    setTrainingCheck(false)
    setWorkCheck(false)

    const filteredAddedSkill = addedSkill?.filter(
      skill => !addedSkills?.some(added => added?.id === skill?.id)
    )

    setAddedSkill(filteredAddedSkill)
    setAdded(false)
    setAddSkillDisable(false)
    setAddingSkill(null)

  }

 
  const click = async () => {
    await dispatch(getStudentData())
    setWorkExperienceDrawer(true)
  }

  const clickIntern = async () => {
    await dispatch(getStudentData())
    setInternshipDrawer(true)
  }

  const clickProject = async () => {
    await dispatch(getStudentData())
    setProjectDrawer(true)
  }

  const clickTraining = async () => {
    await dispatch(getStudentData())
    setCourseTrainingDrawer(true)
  }

  const clickEducation = async () => {
    await dispatch(getStudentData())
    setEduModalVisible(true)
  }

  const handleAddSkillClick = item => {
    const newSkill = {
      ...item,
    }
    setAddedSkills(() => [newSkill])
    setAddedSkill(prevAllSkills => [...prevAllSkills, newSkill])
    setAdded(true)
    setAddingSkill(item)
    setAddSkillDisable(true)
    setAdd(false)
  }

  const handleEducationCheck = e => {
    setSelectedEdu([])
    setEducationCheck(e.target.checked)
    setEducationList(
      roleFloatList?.academics?.filter(item => item.educationLevel)
    )
  }

  const handleWorkCheck = e => {
    setSelectedWork([])
    setWorkCheck(e.target.checked)
    setWorkList(roleFloatList?.workExperience?.filter(item => item.id))
  }

  const handleInternshipCheck = e => {
    setSelectedIntern([])
    setInternCheck(e.target.checked)
    setInternList(roleFloatList?.internships?.filter(item => item.id))
  }

  const handleTrainingCheck = e => {
    setSelectedTraining([])
    setTrainingCheck(e.target.checked)
    setTrainingList(roleFloatList?.courses?.filter(item => item.id))
  }

  const handleProjectCheck = e => {
    setSelectedProject([])
    setProjectCheck(e.target.checked)
    setProjectList(roleFloatList?.projects?.filter(item => item.id))
  }

  const SubmitDataSkill = async () => {
    setEducationCheck(false)
    setProjectCheck(false)
    setInternCheck(false)
    setTrainingCheck(false)
    setWorkCheck(false)
    const skillDetails = addedSkills?.map(item => {
      return {
        id: item?.id,
        name: item?.name,
        academics: selectedEdu,
        projects: selectedProject,
        courses: selectedTraining,
        workExperience: selectedWork,
        internships: selectedIntern,
        training: [],
      }
    })

    let payload = {
      skillDetails: [...skillDetails],
      locations: [],
      checkForApproval: true,
      checkDeleteSection: ['education', 'projects', 'workExperience', 'internships', 'courses'],
    }

    let response = await updateRoleFloatDetails(payload, itemId)
    await fetchEligleDetailsNotLoading()
    if (response?.status == 200) {
      setUpdateResponse(
        response?.data?.data?.eligibleDetails?.skills?.isEligible
      )
      
      // Calculate message based on eligibility data
      const eligData = response?.data?.data?.eligibleDetails;
      const newMessage = calculateEligibilityMessage(eligData);
      setMessageState(newMessage);
      SuccessMessage('Skills added successfully!')
      setAdded(false)
      setAddedAllSkills(addedSkill)
      setAdd(true)
      setAddSkills(true)
      setAddSkillDisable(false)
      fetchEligleDetails()
      clearSelectedList()
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }

  const SubmitDataLocation = async () => {
    const locationDetails = combinedArrayLocation?.map(item => {
      return item
    })
    
    let payload = {
      skillDetails: [],
      locations: [...locationDetails],
      checkForApproval: true,
      checkDeleteSection: ['studentPersonalProfile'],
    }

    let response = await updateRoleFloatDetails(payload, itemId)
    if (response?.status == 200) {
      let resultData = await fetchEligleDetails()
      let res = await getEligibleDetails({ roleID: itemId, setLoading })
      if ((res?.isEligible && resultData?.isArrearEligible
        && resultData?.isDegreeEligible && resultData?.isExperienceEligible && 
        resultData?.isLocationEligible && resultData?.isScoreEligible && 
        resultData?.isSkillEligible && resultData?.isYearOfPassingEligible) || (accessLevel === 0 || accessLevel === 2)
      ) {
        if (selectedNew?.role?.questionBankRoleMap?.length) {
          setRoleDrawer(false)
          setSelected(selectedNew)
          setQuestionnaireModal(true)
        } else if (selectedNew?.roleId) {
          setRoleDrawer(false)
          onApplyClick(selectedNew)
        } else {
          SuccessMessage('Updated Successfully!')
          setRoleDrawer(false)
          UpdatedSkills()
        }
      } else {
        ErrorMessage('Still you are not eligible to apply the role')
        setRoleDrawer(false)
        UpdatedSkills()
      }
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }

  const content = () => {
    const handleCheck = e => {
      const newChecked = e.target.checked
      setChecked(newChecked)
      if (newChecked) {
        const allLocationIds = eligibleList?.locations?.allLocations.map(
          item =>  item?.id ?? item?.state_id
        )
        setSelectedLocation(allLocationIds)
      } else {
        setSelectedLocation([])
      }
    }

    // const isSkillsEligible =
    //   updateResponse === false && !eligibleList?.skills?.isEligible
    // const isLocationEligible = !eligibleList?.locations?.isEligible
    // const isExperienceEligible = !eligibleList?.experience?.isEligible

    // const hasEligibilityIssue =
    //   isSkillsEligible || isLocationEligible || isExperienceEligible

    // let message = ''

    // const hasNonEmptySkillSet = eligibleList?.skills?.otherMandatory?.some(
    //   skillSet => skillSet?.skills?.length > 0
    // )
    // if (hasEligibilityIssue) {
    //   if (isSkillsEligible && isLocationEligible && isExperienceEligible) {
    //     message = 'skills, location, and work experience'
    //   } else if (isSkillsEligible && isLocationEligible) {
    //     message = 'skills and location'
    //   } else if (isSkillsEligible && isExperienceEligible) {
    //     message = 'skills and work experience'
    //   } else if (isLocationEligible && isExperienceEligible) {
    //     message = 'location and work experience'
    //   } else {
    //     if (isSkillsEligible) {
    //       message += 'skills'
    //     }
    //     if (isLocationEligible) {
    //       if (message) message += ' and '
    //       message += 'location'
    //     }
    //     if (isExperienceEligible) {
    //       if (message) message += ' and '
    //       message += 'work experience'
    //     }
    //   }

    //   //message = `Due to a lack of matching ${message}, you are not eligible to apply for this role.`
    // }

    return (
      <>
        {loading && (
          <SpinWrapper center>
            <Spin />
          </SpinWrapper>
        )}
        {!loading && (
          <>
            {!showComponent && (
              <SpinWrapper center style={{ width: '100%', margin: '200px' }}>
                <Spin />
              </SpinWrapper>
            )}
            <div
              style={{ display: 'flex', width: '100%', background: 'white' }}
            >
              {showComponent && (
                <>
                  <div style={{ width: '100%' }}>
                    {/* <HeaderFixed>
                      <FlexWrapRole centerVertically gap="20px">
                        {!updateResponse ||
                        !eligibleList?.locations?.isEligible ||
                        !eligibleList?.experience?.isEligible ? (
                          <>
                            <ExclamationCircleFilled
                              style={{ fontSize: '20px', color: '#E35E50' }}
                            />
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: '16px',
                                lineHeight: '25px',
                                color: '#343E59',
                              }}
                            >
                              {message}
                            </div>
                            <StyledDiv onClick={onClear}>
                              <CrossIconSkill />
                            </StyledDiv>
                          </>
                        ) : (
                          <>
                          {eligibilityCriteria?.isEligible ? <>
                            <ThumbsUpIcon />
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: '16px',
                                lineHeight: '25px',
                                color: '#343E59',
                              }}
                            >
                              {'Now you are eligible to apply this role !'}
                            </div>
                            <ExtraPaddingLeft />
                            </>  :
                            
                            <> 
                            
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: '16px',
                                lineHeight: '25px',
                                color: '#343E59',
                                display: 'none'
                              }}
                            >
                              {message}
                            </div>
                            </>
                            }
                            
                            <StyledDiv onClick={onClear}>
                              <CrossIconSkill />
                            </StyledDiv>
                          </>
                        )}
                      </FlexWrapRole>
                      <HorizontalDivider
                        style={{ marginTop: '12px', marginBottom: '10px' }}
                      />
                    </HeaderFixed> */}
                    <ContentStyle>
                      <FlexWrapRole spaceBetween centerVertically gap="20px">
                       
                          <>
                            {eligibilityCriteria?.isEligible ? (
                              <>
                                
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: '16px',
                                    lineHeight: '25px',
                                    color: '#343E59',
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <span style={{ display: 'inline-flex', marginRight: '8px' }}>
                                    <ThumbsUpIcon />
                                  </span>
                                  {'Now you are eligible to apply this role!'}
                                </div>
                                <ExtraPaddingLeft />
                              </>
                            ) : (
                              <>
                              <div
                                style={{
                                  fontWeight: 600,
                                  fontSize: '16px',
                                  lineHeight: '25px',
                                  color: '#343E59',
                                }}
                              >
                                <span>
                                  <ExclamationCircleFilled
                                    style={{ fontSize: '20px', color: '#E35E50' }}
                                  />
                                </span>
                                {messageState ? `Due to a lack of matching ${messageState}, you are not eligible to apply for this role.` : 'You are not eligible to apply for this role.'}
                              </div>
                              <StyledDiv onClick={onClear}>
                                <CrossIconSkill />
                              </StyledDiv>
                            </>
                            )}
                          </>
                       
                      </FlexWrapRole>
                      <HorizontalDivider
                        style={{ marginTop: '12px', marginBottom: '10px' }}
                      />
                      <div
                        style={{
                          paddingLeft: '25px',
                          paddingTop: '20px',
                          paddingRight: '10px',
                        }}
                      >
                        {!skillVisible && (
                          <>
                            <SkillsHeading>Skills</SkillsHeading>
                            
                            {/* Mandatory Skills Section */}
                            {eligibleList?.skills?.skillList?.some(skill => skill.isMandatory) && (
                              <>
                                <SkillsSubHeading style={{ display: 'inline' }}>
                                  Mandatory Skills
                                </SkillsSubHeading>
                                <CountHeading style={{ display: 'inline' }}>
                                  ({eligibleList?.skills?.skillList?.filter(skill => skill.isMandatory)?.length} {eligibleList?.skills?.skillList?.filter(skill => skill.isMandatory)?.length === 1 ? 'skill is' : 'skills are'} mandatory)
                                </CountHeading>
                                <SkillsHeadingPadding />
                                
                                {eligibleList?.skills?.skillList
                                  ?.filter(item => item.isMandatory)
                                  ?.map((item, index) => {
                                    const isSkillAdded = addedAllSkills?.some(
                                      addedItem => addedItem?.id === item?.id
                                    );
                                    
                                    return (
                                      <ExtraPaddingLeftSkill key={index + 'mandatorySkill'}>
                                        <TopHeading
                                          isAdded={addingSkill === item && !add}
                                          key={item?.id}
                                          disable={
                                            (addSkillDisable && addingSkill != item) ||
                                            (addSkills && isSkillAdded) ||
                                            item?.isAdded
                                          }
                                        >
                                          <div>
                                            {item?.isAdded ? (
                                              <CheckIconBlue />
                                            ) : addSkills && isSkillAdded ? (
                                              <CheckIconGreen />
                                            ) : (
                                              <CheckIconGrey />
                                            )}
                                          </div>
                                          <SkillHeading
                                            color={item?.isAdded ? '#3249D7' : '#343E59'}
                                          >
                                            {item?.name}
                                          </SkillHeading>
                                          {item?.isAdded ? null : addSkills && isSkillAdded ? (
                                            <AddedSkillHeading
                                              style={{
                                                display: 'inline',
                                                whiteSpace: 'nowrap',
                                              }}
                                            >
                                              Added
                                            </AddedSkillHeading>
                                          ) : (
                                            <AddSkillHeading
                                              onClick={() =>
                                                !addSkillDisable && handleAddSkillClick(item)
                                              }
                                              isAdded={addingSkill === item}
                                              disable={addSkillDisable && addingSkill != item}
                                              style={{
                                                display: 'inline',
                                                whiteSpace: 'nowrap',
                                              }}
                                            >
                                              + Add Skill
                                            </AddSkillHeading>
                                          )}
                                        </TopHeading>
                                      </ExtraPaddingLeftSkill>
                                    );
                                  })}
                              </>
                            )}
                            
                            <ExtraPaddingNew />
                            
                            {/* Non-Mandatory Skills Section */}
                            {eligibleList?.skills?.skillList?.some(skill => !skill.isMandatory) && (
                              <>
                                <SkillsSubHeading style={{ display: 'inline' }}>
                                  Non-Mandatory Skills
                                </SkillsSubHeading>
                                <SkillsHeadingPadding />
                                
                                {eligibleList?.skills?.skillList
                                  ?.filter(item => !item.isMandatory)
                                  ?.map((item, index) => {
                                    const isSkillAdded = addedAllSkills?.some(
                                      addedItem => addedItem?.id === item?.id
                                    );
                                    
                                    return (
                                      <ExtraPaddingLeftSkill key={index + 'nonMandatorySkill'}>
                                        <TopHeading
                                          isAdded={addingSkill === item && !add}
                                          key={item?.id}
                                          disable={
                                            (addSkillDisable && addingSkill != item) ||
                                            (addSkills && isSkillAdded) ||
                                            item?.isAdded
                                          }
                                        >
                                          <div>
                                            {item?.isAdded ? (
                                              <CheckIconBlue />
                                            ) : addSkills && isSkillAdded ? (
                                              <CheckIconGreen />
                                            ) : (
                                              <CheckIconGrey />
                                            )}
                                          </div>
                                          <SkillHeading
                                            color={item?.isAdded ? '#3249D7' : '#343E59'}
                                          >
                                            {item?.name}
                                          </SkillHeading>
                                          {item?.isAdded ? null : addSkills && isSkillAdded ? (
                                            <AddedSkillHeading
                                              style={{
                                                display: 'inline',
                                                whiteSpace: 'nowrap',
                                              }}
                                            >
                                              Added
                                            </AddedSkillHeading>
                                          ) : (
                                            <AddSkillHeading
                                              onClick={() =>
                                                !addSkillDisable && handleAddSkillClick(item)
                                              }
                                              isAdded={addingSkill === item}
                                              disable={addSkillDisable && addingSkill != item}
                                              style={{
                                                display: 'inline',
                                                whiteSpace: 'nowrap',
                                              }}
                                            >
                                              + Add Skill
                                            </AddSkillHeading>
                                          )}
                                        </TopHeading>
                                      </ExtraPaddingLeftSkill>
                                    );
                                  })}
                              </>
                            )}
                          </>
                        )}

                        {!skillVisible && !locationVisible && (
                          <HorizontalDivider style={{ marginBottom: '20px' }} />
                        )}

                        <div style={{ marginTop: 'auto' }}>
                          <div style={{ paddingLeft: '5px' }}>
                            {!locationVisible &&
                              !(
                                eligibleList?.locations?.studentIsAnyWhere ||
                                eligibleList?.locations?.roleLocationAyWhere ||
                                allLocationsAdded
                              ) && (
                                <>
                                  <SkillsHeading>Location</SkillsHeading>
                                  <LocationDescription>
                                    This role requires {requiredLocations} as
                                    job location, but your preferred location is{' '}
                                    {preferredLocationsString}
                                  </LocationDescription>
                                  <LocationNote>
                                    NOTE : Please add your preferred location
                                  </LocationNote>
                                  <CheckboxSelectAll
                                    value={checked}
                                    onChange={handleCheck}
                                    label={'Select All'}
                                    disabled={addSkillDisable}
                                  />

                                  <FilterCheckBoxComp
                                    value={selectedLocation}
                                    options={locationList}
                                    onChange={onCheckboxLocation}
                                    valueParam="id"
                                    labelParam="name"
                                    disabled={addSkillDisable}
                                  />
                                </>
                              )}
                          </div>

                          {!locationVisible && !expVisible && (
                            <HorizontalDivider
                              style={{
                                marginTop: '12px',
                                marginBottom: '20px',
                              }}
                            />
                          )}

                          <div style={{ paddingLeft: '5px' }}>
                            {!skillVisible &&
                              locationVisible &&
                              !expVisible && (
                                <HorizontalDivider
                                  style={{
                                    marginTop: '12px',
                                    marginBottom: '20px',
                                  }}
                                />
                              )}
                            {console.log(
                              eligibleList?.experience?.isExpCandidate,
                              ' : :eligibleList?.experience?.isExpCandidate'
                            )}
                            {!expVisible && (
                              <>
                                <ExperienceDescription>
                                  This role requires {experienceFromDate} -{' '}
                                  {experienceToDate} years of experience, but
                                  you have {yearCalculate} of
                                  experience.
                                </ExperienceDescription>

                                <ButtonLocal
                                  disabled={
                                    studentExperience >= experienceFromDate ||
                                    addSkillDisable
                                  }
                                >
                                  <Control
                                    alignCenter
                                    gap="10px"
                                    onClick={click}
                                  >
                                    <AdjustIcon>
                                      <AddIcon />
                                    </AdjustIcon>
                                    <Text>Add Experience</Text>
                                  </Control>
                                </ButtonLocal>

                                {studentExperience >= experienceFromDate &&
                                  studentExperience <= experienceToDate && (
                                    <ExperienceNote>
                                      You meet the work experience eligibility
                                      criteria for this job with your{' '}
                                      {yearCalculate} of experience.
                                    </ExperienceNote>
                                  )}

                                {studentExperience > experienceToDate && (
                                  <ExperienceNote>
                                    You exceed the required experience for this
                                    job with your {yearCalculate} of
                                    experience.
                                  </ExperienceNote>
                                )}
                              </>
                            )}

                            <ExtraPaddingLast />
                          </div>
                        </div>
                      </div>
                      {/* <HorizontalDividerTitle
                        style={{ marginBottom: '12px' }}
                      /> */}

              
                    </ContentStyle>

                    {/* <FooterFixed>
                      <HorizontalDividerTitle
                        style={{ marginBottom: '12px' }}
                      />

                      <FlexWrapRole gap="20px" right>
                        <>
                          <Button.Secondary text="Cancel" onClick={onClear} />
                          <Button.Primary
                            onClick={SubmitDataLocation}
                            form={formId}
                            text={'Update and Apply'}
                            disabled={
                              !(
                                combinedArrayLocation?.length > 0 ||
                                addSkills ||
                                expDrawer
                              )
                            }
                          />
                        </>
                      </FlexWrapRole>
                    </FooterFixed> */}
                  </div>
                </>
              )}

              {/* New Experience Modal */}
              <ExperienceModal
                visible={added}
                onClose={onClearSkill}
                roleFloatList={roleFloatList}
                educationCheck={educationCheck}
                handleEducationCheck={handleEducationCheck}
                selectedEdu={selectedEdu}
                educationList={educationList}
                onCheckboxEdu={onCheckboxEdu}
                workCheck={workCheck}
                handleWorkCheck={handleWorkCheck}
                selectedWork={selectedWork}
                workList={workList}
                onCheckboxWork={onCheckboxWork}
                internCheck={internCheck}
                handleInternshipCheck={handleInternshipCheck}
                selectedIntern={selectedIntern}
                internList={internList}
                onCheckboxIntern={onCheckboxIntern}
                trainingCheck={trainingCheck}
                handleTrainingCheck={handleTrainingCheck}
                selectedTraining={selectedTraining}
                trainingList={trainingList}
                onCheckboxTraining={onCheckboxTraining}
                projectCheck={projectCheck}
                handleProjectCheck={handleProjectCheck}
                selectedProject={selectedProject}
                projectList={projectList}
                onCheckboxProject={onCheckboxProject}
                onSubmit={SubmitDataSkill}
                formId={formId}
                studentExperience={studentExperience}
                experienceFromDate={experienceFromDate}
                addSkillDisable={addSkillDisable}
                click={click}
                clickIntern={clickIntern}
                clickProject={clickProject}
                clickTraining={clickTraining}
                clickEducation={clickEducation}
                addingSkill={addingSkill?.name}
                
              />
            </div>
          </>
        )}
      </>
    )
  }

  const footer = () => {
    return (
      <FlexWrapRole gap="20px" right style={{ position: 'sticky', bottom: 0, background: 'white', zIndex: 10 }}>
        <>
          <Button.Secondary text="Cancel" onClick={onClear} />
          <Button.Primary
            onClick={SubmitDataLocation}
            form={formId}
            text={'Update and Apply'}
            disabled={
              !(
                (combinedArrayLocation?.length > 0 ||
                addSkills ||
                expDrawer) ||
                accessLevel === 0 ||
                accessLevel === 2
              )
            }
          />
        </>
      </FlexWrapRole>
    )
  }

  return (
    <StyledModal
      visible={roleDrawer}
      width={'80%'}
      centered
      maskClosable={false}
      footer={footer()}
      destroyOnClose={true}
      closable={false}
    >
      {content()}
    </StyledModal>
  )
}

export default SkillBasedRoleModal
